var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"common-report consulatnt-workload-view"},[_c('ConsultantworkloadRelation'),_c('ConsultantworkloadAllocation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }